export default __webpack_public_path__ + "static/media/zeroGuide3.53e50c42.png";